import React from 'react';
import ProductsShowcase from './ProductsShowcase';

export default function Products() {
  return <ProductsShowcase />;
}
